import OverlayTips from "../OverlayTips";

function FeaturesPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

FeaturesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle span"), {
            messageKey: "tips.features.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });
    }
});

export default FeaturesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/FeaturesPageOverlayTipsManager.js